// src/components/branded-deal-cross-sell-flight/branded-deal-cross-sell-flight.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    link: url\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    url {\n      value\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n    ...EGDSMarkFragment\n    ...EGDSIllustrationFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSProgramBadgeFragment on EGDSProgramBadge {\n    accessibility\n    graphic {\n      ...UIGraphicFragment\n    }\n    text\n    theme\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealUILinkActionFields on MultiItemCrossSellUILinkAction {\n    accessibility\n    label\n    resource {\n      value\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      id\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    size\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    decorative\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    action {\n      accessibility\n      target\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    icon {\n      id\n    }\n    iconPosition\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextItemFragment on EGDSSpannableTextItem {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSParagraphFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSSpannableTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealUIBadgeFields on MultiItemCrossSellUIBadge {\n    text\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealUIHeaderTextFields on MultiItemCrossSellUIHeaderText {\n    text\n    level\n    size\n    accessibility\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealUIImageWithTextFields on BrandedDealCrossSellUIImageWithText {\n    description {\n      text\n      theme\n    }\n    image {\n      url\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealUITextFields on MultiItemCrossSellUIText {\n    text\n    theme\n    accessibility\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealCrossSellUIContentFragment on BrandedDealCrossSellUIContent {\n    primaryContent {\n      details {\n        ...BrandedDealUIHeaderTextFields\n        ...BrandedDealUITextFields\n        ...BrandedDealUIImageWithTextFields\n      }\n    }\n    secondaryContent {\n      details {\n        ...BrandedDealUITextFields\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment BrandedDealCrossSellUIContentItemFragment on BrandedDealCrossSellUIContentItem {\n    ...BrandedDealCrossSellUIContentFragment\n    ...EGDSStylizedTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  query BrandedDealCrossSellQuery(\n    $context: ContextInput!\n    $searchContext: MultiItemSearchContextInput!\n    $multiItemProducts: MultiItemProductsInput\n    $price: BrandedDealProductPriceInput!\n  ) {\n    crossSell(context: $context, searchContext: $searchContext, selectedProducts: $multiItemProducts) {\n      static {\n        brandedDealListing(price: $price) {\n          action {\n            ...BrandedDealUILinkActionFields\n          }\n          actionBar {\n            ...BrandedDealUILinkActionFields\n          }\n          crossSellBadges {\n            ...EGDSProgramBadgeFragment\n          }\n          brandedDealContent {\n            ...BrandedDealCrossSellUIContentItemFragment\n          }\n          impressionAnalytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
import React24 from "react";
import { gql as gql21, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-program-badge/egds-program-badge.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkBadgeProgram } from "uitk-react-badge";
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment = gql(_templateObject());
var EGDSIcon = function(param) {
    var data = param.data, defaultIconSize = param.defaultIconSize, defaultIconTheme = param.defaultIconTheme;
    var description = data.description, id = data.id, size = data.size, title = data.title, theme = data.theme, withBackground = data.withBackground;
    return /* @__PURE__ */ React.createElement(UitkIcon, {
        description: description,
        id: id,
        name: id,
        size: size ? UitkIconSize[size] : defaultIconSize,
        title: title !== null && title !== void 0 ? title : void 0,
        theme: theme !== null && theme !== void 0 ? theme : defaultIconTheme,
        shadow: Boolean(withBackground)
    });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = fragment;
// ../internal/src/components/egds-illustration/egds-illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment2 = gql2(_templateObject1());
var EGDSIllustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React2.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
EGDSIllustration.displayName = "EGDSIllustration";
EGDSIllustration.fragment = fragment2;
// ../internal/src/components/egds-mark/edgs-mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment3 = gql3(_templateObject2());
var EGDSMark = function(param) {
    var data = param.data, size = param.size;
    var _data_url;
    if (!data.url && !data.id) {
        return null;
    }
    return /* @__PURE__ */ React3.createElement(UitkMark, {
        description: data.description,
        id: data.id,
        name: data.id,
        size: size,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = fragment3;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
var fragment4 = gql4(_templateObject3(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var UIGraphic = function(param) {
    var data = param.data, markProps = param.markProps, iconProps = param.iconProps;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(EGDSIcon, _object_spread({
                data: data
            }, iconProps));
        case "Mark":
            return /* @__PURE__ */ React4.createElement(EGDSMark, _object_spread({
                data: data
            }, markProps));
        case "Illustration":
            return /* @__PURE__ */ React4.createElement(EGDSIllustration, {
                data: data
            });
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment4;
// ../internal/src/components/egds-program-badge/egds-program-badge.tsx
var fragment5 = gql5(_templateObject4(), UIGraphic.fragment);
var themeMap = {
    deal: "deal",
    member: "member",
    trip: "trip",
    supplierpromo: "supplierpromo",
    vmce: "vmc"
};
var EGDSProgramBadge = function(param) {
    var data = param.data, iconSize = param.iconSize;
    var accessibility = data.accessibility, graphic = data.graphic, text = data.text, theme = data.theme;
    if (!text || !theme) {
        return null;
    }
    return /* @__PURE__ */ React5.createElement(UitkBadgeProgram, {
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        text: text,
        theme: themeMap[theme]
    }, graphic && /* @__PURE__ */ React5.createElement(UIGraphic, {
        data: graphic,
        iconProps: {
            defaultIconSize: iconSize
        }
    }));
};
EGDSProgramBadge.displayName = "EGDSProgramBadge";
EGDSProgramBadge.fragment = fragment5;
// src/components/branded-deal-cross-sell-flight/branded-deal-cross-sell-flight.tsx
import { UitkCard, UitkCardActionArea, UitkCardContentSection as UitkCardContentSection3, UitkCardLink } from "uitk-react-cards";
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-ui-link-action.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment6 = gql6(_templateObject5());
var BrandedDealUILinkAction = function(param) {
    var _param_data = param.data, accessibility = _param_data.accessibility, label = _param_data.label, resource = _param_data.resource, analytics = _param_data.analytics, icon = _param_data.icon;
    var _icon;
    var clickTracker = useClickTracker();
    var onClick = React6.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName, false);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React6.createElement(UitkSpacing, {
        margin: {
            blockstart: "two"
        },
        padding: "one"
    }, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(UitkLink, {
        onClickCapture: onClick,
        inline: true
    }, /* @__PURE__ */ React6.createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: resource.value
    }, label, ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React6.createElement(UitkIcon2, {
        name: icon.id
    }), /* @__PURE__ */ React6.createElement(UitkText, {
        className: "is-visually-hidden"
    }, accessibility)))));
};
BrandedDealUILinkAction.fragment = fragment6;
BrandedDealUILinkAction.displayName = "BrandedDealUILinkAction";
BrandedDealUILinkAction.fragment.__typename = "MultiItemCrossSellUILinkAction";
// src/components/branded-deal-cross-sell-flight/__private/branded-deal-cross-ui-content-item.tsx
import React23 from "react";
import { gql as gql20 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-heading.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var fragment7 = gql7(_templateObject6());
var EGDSHeading = function(param) {
    var headingProps = param.headingProps, data = param.data;
    return /* @__PURE__ */ React7.createElement(UitkHeading, _object_spread({}, headingProps), data.text);
};
EGDSHeading.fragment = fragment7;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment8 = gql8(_templateObject7());
var UitkParagraphSizeMap = {
    1: 1,
    2: 2,
    3: 3
};
var _UitkParagraphSizeMap_size;
var EGDSParagraph = function(param) {
    var _param_data = param.data, size = _param_data.size, text = _param_data.text;
    return /* @__PURE__ */ React8.createElement(UitkParagraph, {
        size: (_UitkParagraphSizeMap_size = UitkParagraphSizeMap[size]) !== null && _UitkParagraphSizeMap_size !== void 0 ? _UitkParagraphSizeMap_size : void 0
    }, text);
};
EGDSParagraph.fragment = fragment8;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment9 = gql9(_templateObject8());
var EGDSPlainText = function(param) {
    var textProps = param.textProps, data = param.data;
    return /* @__PURE__ */ React9.createElement(UitkText2, _object_spread({}, textProps), data.text);
};
EGDSPlainText.fragment = fragment9;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment10 = gql10(_templateObject9());
var _obj;
var UitkTextThemeMap = (_obj = {}, _define_property(_obj, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj, "INVERSE" /* INVERSE */ , "inverse"), _obj);
var _obj1;
var UitkTextWeightMap = (_obj1 = {}, _define_property(_obj1, "BOLD" /* BOLD */ , "bold"), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj1, "REGULAR" /* REGULAR */ , "regular"), _obj1);
var EGDSStylizedText = function(props) {
    var data = props.data, textProps = props.textProps;
    var text = data.text, theme = data.theme, weight = data.weight, decorative = data.decorative;
    var textTheme = theme ? UitkTextThemeMap[theme] : void 0;
    var textWeight = weight ? UitkTextWeightMap[weight] : void 0;
    var _textProps_theme;
    var StylizedText = function() {
        var _textProps, _textProps1, _textProps2;
        return /* @__PURE__ */ React10.createElement(UitkText3, {
            size: (_textProps = textProps) === null || _textProps === void 0 ? void 0 : _textProps.size,
            theme: (_textProps_theme = (_textProps1 = textProps) === null || _textProps1 === void 0 ? void 0 : _textProps1.theme) !== null && _textProps_theme !== void 0 ? _textProps_theme : textTheme,
            weight: textWeight,
            inline: (_textProps2 = textProps) === null || _textProps2 === void 0 ? void 0 : _textProps2.inline
        }, text);
    };
    switch(decorative){
        case "LINE_THROUGH" /* LINE_THROUGH */ :
            return /* @__PURE__ */ React10.createElement("s", null, /* @__PURE__ */ React10.createElement(StylizedText, null));
        default:
            return /* @__PURE__ */ React10.createElement(StylizedText, null);
    }
};
EGDSStylizedText.fragment = fragment10;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-text.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/egds-link/egds-standard-link.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment11 = gql11(_templateObject10());
var _obj2;
var UILinkTargetMap = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank" /* EXTERNAL */ ), _define_property(_obj2, "INTERNAL" /* INTERNAL */ , "_self" /* INTERNAL */ ), _obj2);
var EGDSStandardLink = function(param) {
    var data = param.data, inline = param.inline, iconSize = param.iconSize;
    var action = data.action, text = data.text, icon = data.icon, iconPosition = data.iconPosition;
    var analytics = action.analytics, resource = action.resource, target = action.target, accessibility = action.accessibility;
    var clickTracker = useClickTracker2();
    var onClick = React11.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React11.createElement(UitkLink2, {
        onClickCapture: onClick,
        inline: inline !== null && inline !== void 0 ? inline : true
    }, /* @__PURE__ */ React11.createElement("a", {
        target: UILinkTargetMap[target],
        href: resource.value
    }, icon && iconPosition !== "TRAILING" /* TRAILING */  && /* @__PURE__ */ React11.createElement(UitkIcon3, {
        name: icon.id,
        size: iconSize
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React11.createElement(UitkIcon3, {
        name: icon.id,
        size: iconSize
    }), accessibility && /* @__PURE__ */ React11.createElement(UitkText4, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.displayName = "EGDSStandardLink";
EGDSStandardLink.fragment = fragment11;
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-item.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
var fragment12 = gql12(_templateObject11(), EGDSStylizedText.fragment, EGDSPlainText.fragment);
var EGDSSpannableTextItem = function(param) {
    var data = param.data, textProps = param.textProps;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React12.createElement(EGDSStylizedText, {
                data: data,
                textProps: textProps
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React12.createElement(EGDSPlainText, {
                data: data,
                textProps: textProps
            });
        default:
            return null;
    }
};
EGDSSpannableTextItem.fragment = fragment12;
EGDSSpannableTextItem.displayName = "EGDSSpannableTextItem";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment13 = gql13(_templateObject12(), EGDSSpannableTextItem.fragment);
var spannableSpacing = {
    margin: {
        inlineend: "one"
    }
};
var EGDSSpannableText = function(props) {
    var data = props.data, textProps = _object_without_properties(props, [
        "data"
    ]);
    if (data.inlineContent.length === 0) {
        return /* @__PURE__ */ React13.createElement(UitkText5, _object_spread({}, textProps), data.text);
    }
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, data.inlineContent.map(function(item, index) {
        return /* @__PURE__ */ React13.createElement(UitkSpacing2, _object_spread_props(_object_spread({}, spannableSpacing), {
            key: "spannable-text-item-".concat(index)
        }), /* @__PURE__ */ React13.createElement(EGDSSpannableTextItem, _object_spread({
            data: item
        }, textProps)));
    }));
};
EGDSSpannableText.fragment = fragment13;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment14 = gql14(_templateObject13(), EGDSHeading.fragment, EGDSParagraph.fragment, EGDSPlainText.fragment, EGDSStandardLink.fragment, EGDSStylizedText.fragment, EGDSSpannableText.fragment);
var EGDSText = function(param) {
    var data = param.data, headingProps = param.headingProps, textProps = param.textProps;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React14.createElement(EGDSHeading, {
                data: data,
                headingProps: headingProps
            });
        case "EGDSParagraph":
            return /* @__PURE__ */ React14.createElement(EGDSParagraph, {
                data: data
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React14.createElement(EGDSPlainText, {
                data: data,
                textProps: textProps
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React14.createElement(EGDSStandardLink, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React14.createElement(EGDSStylizedText, {
                data: data,
                textProps: textProps
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React14.createElement(EGDSSpannableText, {
                data: data,
                textProps: textProps
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment14;
EGDSText.displayName = "EGDSText";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-cross-sell-ui-content.tsx
import React22 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkLayoutGrid, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
// src/components/branded-deal-cross-sell-flight/__private/sections/branded-deal-primary-content.tsx
import React20 from "react";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
// src/components/branded-deal-cross-sell-flight/__private/branded-deal-ui-elements.tsx
import React19 from "react";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-ui-badge.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkDealGenericBadge } from "uitk-react-badge";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var fragment15 = gql15(_templateObject14());
var BrandedDealUIBadge = function(param) {
    var text = param.data.text;
    return /* @__PURE__ */ React15.createElement(UitkSpacing3, {
        padding: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(UitkDealGenericBadge, {
        text: text
    })));
};
BrandedDealUIBadge.fragment = fragment15;
BrandedDealUIBadge.displayName = "BrandedDealUIBadge";
BrandedDealUIBadge.fragment.__typename = "MultiItemCrossSellUIBadge";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-ui-header.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText6 } from "uitk-react-text";
var fragment16 = gql16(_templateObject15());
var tagMap = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
var sizeMap = {
    900: 1,
    800: 2,
    700: 3,
    600: 4,
    500: 5,
    400: 6,
    300: 7
};
var BrandedDealUIHeaderText = function(param) {
    var _param_data = param.data, text = _param_data.text, level = _param_data.level, size = _param_data.size, accessibility = _param_data.accessibility;
    return /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, accessibility ? /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(UitkText6, {
        className: "is-visually-hidden"
    }, accessibility), /* @__PURE__ */ React16.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React16.createElement(UitkHeading2, {
        tag: tagMap[level],
        size: sizeMap[size]
    }, text))) : /* @__PURE__ */ React16.createElement(UitkHeading2, {
        tag: tagMap[level],
        size: sizeMap[size]
    }, text)));
};
BrandedDealUIHeaderText.fragment = fragment16;
BrandedDealUIHeaderText.displayName = "BrandedDealUIHeaderText";
BrandedDealUIHeaderText.fragment.__typename = "MultiItemCrossSellUIHeaderText";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-ui-image-text.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkMark as UitkMark2, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText7 } from "uitk-react-text";
var _obj3;
// src/components/branded-deal-cross-sell-flight/__private/utils.tsx
var textThemeMapper = (_obj3 = {}, _define_property(_obj3, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj3, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj3, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj3, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj3, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj3, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj3, "INVERSE" /* INVERSE */ , "inverse"), _obj3);
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-ui-image-text.tsx
var fragment17 = gql17(_templateObject16());
var _description_theme;
var BrandedDealUIImageWithText = function(param) {
    var _param_data = param.data, description = _param_data.description, image = _param_data.image;
    return /* @__PURE__ */ React17.createElement(UitkSpacing5, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(UitkLayoutFlex, {
        alignContent: "center",
        space: "one",
        className: "truncate"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React17.createElement(UitkMark2, {
        "aria-hidden": "true",
        url: image.url,
        description: description.text,
        size: UitkMarkSize2.SMALL
    })), /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem, {
        "align-self": "center"
    }, /* @__PURE__ */ React17.createElement(UitkText7, {
        theme: textThemeMapper[(_description_theme = description.theme) !== null && _description_theme !== void 0 ? _description_theme : "SECONDARY" /* SECONDARY */ ],
        size: 200
    }, description.text)))));
};
BrandedDealUIImageWithText.fragment = fragment17;
BrandedDealUIImageWithText.displayName = "BrandedDealUIImageWithText";
BrandedDealUIImageWithText.fragment.__typename = "BrandedDealCrossSellUIImageWithText";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-ui-text.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText8 } from "uitk-react-text";
var fragment18 = gql18(_templateObject17());
var BrandedDealUIText = function(param) {
    var _param_data = param.data, text = _param_data.text, theme = _param_data.theme, accessibility = _param_data.accessibility;
    return /* @__PURE__ */ React18.createElement(UitkSpacing6, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React18.createElement("div", null, accessibility ? /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement(UitkText8, {
        className: "is-visually-hidden"
    }, accessibility), /* @__PURE__ */ React18.createElement("span", {
        "aria-hidden": "true"
    }, /* @__PURE__ */ React18.createElement(UitkText8, {
        theme: textThemeMapper[theme !== null && theme !== void 0 ? theme : "SECONDARY" /* SECONDARY */ ],
        size: 200
    }, text))) : /* @__PURE__ */ React18.createElement(UitkText8, {
        theme: textThemeMapper[theme !== null && theme !== void 0 ? theme : "SECONDARY" /* SECONDARY */ ],
        size: 200
    }, text)));
};
BrandedDealUIText.fragment = fragment18;
BrandedDealUIText.displayName = "BrandedDealUIText";
BrandedDealUIText.fragment.__typename = "MultiItemCrossSellUIText";
// src/components/branded-deal-cross-sell-flight/__private/branded-deal-ui-elements.tsx
var BrandedDealUIElement = function(param) {
    var element = param.element;
    switch(element.__typename){
        case "MultiItemCrossSellUIBadge":
            return /* @__PURE__ */ React19.createElement(BrandedDealUIBadge, {
                data: element
            });
        case "MultiItemCrossSellUIHeaderText":
            return /* @__PURE__ */ React19.createElement(BrandedDealUIHeaderText, {
                data: element
            });
        case "BrandedDealCrossSellUIImageWithText":
            return /* @__PURE__ */ React19.createElement(BrandedDealUIImageWithText, {
                data: element
            });
        case "MultiItemCrossSellUILinkAction":
            return /* @__PURE__ */ React19.createElement(BrandedDealUILinkAction, {
                data: element
            });
        case "MultiItemCrossSellUIText":
            return /* @__PURE__ */ React19.createElement(BrandedDealUIText, {
                data: element
            });
        default:
            return null;
    }
};
var branded_deal_ui_elements_default = BrandedDealUIElement;
// src/components/branded-deal-cross-sell-flight/__private/sections/branded-deal-primary-content.tsx
var BrandedDealPrimaryContent = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React20.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: 1,
            medium: 6
        }
    }, /* @__PURE__ */ React20.createElement(UitkCardContentSection, {
        padded: false
    }, data.details.map(function(cardElement, index) {
        return /* @__PURE__ */ React20.createElement(branded_deal_ui_elements_default, {
            element: cardElement,
            key: "".concat(cardElement, "-").concat(index)
        });
    })));
};
BrandedDealPrimaryContent.displayName = "BrandedDealPrimaryContent";
// src/components/branded-deal-cross-sell-flight/__private/sections/branded-deal-secondary-content.tsx
import React21 from "react";
import { UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
var BrandedDealSecondaryContent = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React21.createElement(UitkLayoutGridItem2, {
        colSpan: {
            small: 1,
            medium: 5
        }
    }, /* @__PURE__ */ React21.createElement(UitkCardContentSection2, {
        padded: false
    }, data.details.map(function(cardElement, index) {
        return /* @__PURE__ */ React21.createElement(branded_deal_ui_elements_default, {
            element: cardElement,
            key: "".concat(cardElement, "-").concat(index)
        });
    })));
};
BrandedDealSecondaryContent.displayName = "BrandedDealSecondaryContent";
// src/components/branded-deal-cross-sell-flight/__private/__fragments/branded-deal-cross-sell-ui-content.tsx
var fragment19 = gql19(_templateObject18(), BrandedDealUIText.fragment, BrandedDealUIHeaderText.fragment, BrandedDealUIImageWithText.fragment);
var BrandedDealCrossSellUIContent = function(param) {
    var _param_data = param.data, primaryContent = _param_data.primaryContent, secondaryContent = _param_data.secondaryContent;
    return /* @__PURE__ */ React22.createElement(UitkLayoutGrid, {
        columns: {
            small: 1,
            medium: 12
        },
        space: "two"
    }, /* @__PURE__ */ React22.createElement(UitkLayoutGridItem3, {
        colSpan: {
            small: 1,
            medium: 9
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutGrid, {
        columns: {
            small: 1,
            medium: 12
        },
        space: "one"
    }, /* @__PURE__ */ React22.createElement(BrandedDealPrimaryContent, {
        data: primaryContent
    }), /* @__PURE__ */ React22.createElement(BrandedDealSecondaryContent, {
        data: secondaryContent
    }))));
};
BrandedDealCrossSellUIContent.fragment = fragment19;
BrandedDealCrossSellUIContent.displayName = "BrandedDealCrossSellUIContent";
// src/components/branded-deal-cross-sell-flight/__private/branded-deal-cross-ui-content-item.tsx
var fragment20 = gql20(_templateObject19(), BrandedDealCrossSellUIContent.fragment, EGDSStylizedText.fragment);
var BrandedDealCrossSellUIContentItem = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "BrandedDealCrossSellUIContent":
            return /* @__PURE__ */ React23.createElement(BrandedDealCrossSellUIContent, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React23.createElement(EGDSStylizedText, {
                data: data,
                textProps: {
                    size: 200
                }
            });
        default:
            return null;
    }
};
BrandedDealCrossSellUIContentItem.fragment = fragment20;
BrandedDealCrossSellUIContentItem.displayName = "BrandedDealCrossSellUIContentItem";
// src/components/branded-deal-cross-sell-flight/branded-deal-cross-sell-flight.tsx
var __Query = gql21(_templateObject20(), EGDSProgramBadge.fragment, BrandedDealUILinkAction.fragment, BrandedDealCrossSellUIContentItem.fragment);
var brandedDealContentItemMargin = {
    blockstart: "one"
};
var offerCardSpacing = {
    padding: {
        inline: "three",
        block: "six"
    }
};
var BrandedDealCrossSellFlight = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, LoadingPlaceholder = param.loadingPlaceholder, NoResultsFallback = param.noResultsFallback, isSmartShoppingFlightCard = param.isSmartShoppingFlightCard;
    var context = useBexApi().context;
    var analyticsTracker = useClickTracker3();
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    React24.useEffect(function() {
        if (data) {
            var _data_crossSell_static_brandedDealListing_impressionAnalytics = data.crossSell.static.brandedDealListing.impressionAnalytics, referrerId = _data_crossSell_static_brandedDealListing_impressionAnalytics.referrerId, linkName = _data_crossSell_static_brandedDealListing_impressionAnalytics.linkName;
            analyticsTracker(referrerId, linkName, false);
        }
        if (error) {
            analyticsTracker("FLT.SR.XSell.FH.BrandedDeals.NotFound", "Flight SR XSell FH Branded Deals Not Found", false);
        }
    }, [
        analyticsTracker,
        data,
        error
    ]);
    var onClick = React24.useCallback(function() {
        if (data) {
            var _data_crossSell_static_brandedDealListing_action_analytics = data.crossSell.static.brandedDealListing.action.analytics, referrerId = _data_crossSell_static_brandedDealListing_action_analytics.referrerId, linkName = _data_crossSell_static_brandedDealListing_action_analytics.linkName;
            analyticsTracker(referrerId, linkName, false);
        }
    }, [
        analyticsTracker,
        data
    ]);
    if (loading) {
        return LoadingPlaceholder ? /* @__PURE__ */ React24.createElement(LoadingPlaceholder, null) : null;
    }
    if (error || !data) {
        return NoResultsFallback ? /* @__PURE__ */ React24.createElement(NoResultsFallback, null) : null;
    }
    var _data_crossSell_static_brandedDealListing = data.crossSell.static.brandedDealListing, crossSellBadges = _data_crossSell_static_brandedDealListing.crossSellBadges, brandedDealContent = _data_crossSell_static_brandedDealListing.brandedDealContent, action = _data_crossSell_static_brandedDealListing.action, actionBar = _data_crossSell_static_brandedDealListing.actionBar;
    var crossSellContent = function() {
        return /* @__PURE__ */ React24.createElement("div", null, crossSellBadges.map(function(badge, index) {
            return /* @__PURE__ */ React24.createElement(EGDSProgramBadge, {
                data: badge,
                iconSize: UitkIconSize2.EXTRA_SMALL,
                key: "branded-deal-badge-".concat(index)
            });
        }), /* @__PURE__ */ React24.createElement(UitkSpacing7, {
            margin: brandedDealContentItemMargin
        }, /* @__PURE__ */ React24.createElement("div", null, brandedDealContent.map(function(brandedDealContentItem, index) {
            return /* @__PURE__ */ React24.createElement(BrandedDealCrossSellUIContentItem, {
                data: brandedDealContentItem,
                key: "branded-deal-cross-sell-ui-content-item-".concat(index)
            });
        }))), actionBar.length > 0 && /* @__PURE__ */ React24.createElement(UitkCardActionArea, null, /* @__PURE__ */ React24.createElement(UitkLayoutFlex2, {
            alignItems: "end",
            direction: "column"
        }, /* @__PURE__ */ React24.createElement("div", null, actionBar.map(function(actionItem, index) {
            return /* @__PURE__ */ React24.createElement(BrandedDealUILinkAction, {
                data: actionItem,
                key: "action-item__".concat(index)
            });
        })))), /* @__PURE__ */ React24.createElement(UitkCardLink, null, /* @__PURE__ */ React24.createElement("a", {
            "data-stid": "branded-deal-listing__card-link",
            onClickCapture: onClick,
            target: "_blank",
            rel: "noopener noreferrer",
            href: action.resource.value
        }, action.label)));
    };
    if (isSmartShoppingFlightCard) {
        return /* @__PURE__ */ React24.createElement(UitkSpacing7, {
            padding: offerCardSpacing.padding
        }, /* @__PURE__ */ React24.createElement(UitkCardContentSection3, {
            "data-testid": "branded-deal-listing__main",
            "data-stid": "branded-deal-listing__main",
            border: "bottom"
        }, crossSellContent()));
    }
    return /* @__PURE__ */ React24.createElement(UitkCard, {
        "data-testid": "branded-deal-listing__main",
        padded: true
    }, crossSellContent());
};
BrandedDealCrossSellFlight.displayName = "sharedui-BrandedDealCrossSellFlight";
export { BrandedDealCrossSellFlight };
//# sourceMappingURL=index.js.map